export const UNSUBSCRIBE_REQUEST = 'UNSUBSCRIBE_REQUEST';
export const UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_FAILURE = 'UNSUBSCRIBE_FAILURE';
export const UNSUBSCRIBE_CHANGE_BUTTON_ACTION = 'UNSUBSCRIBE_CHANGE_BUTTON_ACTION';
